import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);

  const menuItems = [
    { name: 'Ana Sayfa', href: '/' },
    { 
      name: 'Ürünler', 
      href: '#',
      hasDropdown: true,
      submenu: [
        { name: 'Mutfak Dolabı', href: '/mutfak-dolabi' },
        { name: 'Tüm Tezgah Çeşitleri', href: '/tezgah-cesitleri' },
        { name: 'Yüklük', href: '/yukluk' },
        { name: 'Gardırop', href: '/gardirop' },
        { name: 'Vestiyer', href: '/vestiyer' },
        { name: 'Giyinme Odası', href: '/giyinme-odasi' },
        { name: 'Yatak Odası Takımı', href: '/yatak-odasi-takimi' },
        { name: 'Raf Sistemleri', href: '/raf-sistemleri' },
        { name: 'Proje-Tasarım', href: '/proje-tasarim' },
      ]
    },
    { name: 'Hakkımızda', href: '#about' },
    { name: 'İletişim', href: '#contact' },
  ];

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <h1 className="text-3xl font-bold text-amber-700" style={{ fontFamily: '"Pacifico", serif' }}>
                OlmezMobilya
              </h1>
            </Link>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            {menuItems.map((item) => (
              <div key={item.name} className="relative group">
                {item.hasDropdown ? (
                  <div>
                    <button
                      onClick={() => setIsProductsOpen(!isProductsOpen)}
                      className="text-gray-700 hover:text-amber-700 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-1"
                    >
                      {item.name}
                      <i className={`ri-arrow-${isProductsOpen ? 'up' : 'down'}-s-line text-lg`}></i>
                    </button>
                    {isProductsOpen && (
                      <div 
                        className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl py-2 border border-gray-100"
                        onMouseLeave={() => setIsProductsOpen(false)}
                      >
                        {item.submenu?.map((subItem) => (
                          <Link
                            key={subItem.name}
                            to={subItem.href}
                            className="block px-6 py-3 text-gray-700 hover:bg-amber-50 hover:text-amber-700 transition-colors duration-200 cursor-pointer"
                            onClick={() => setIsProductsOpen(false)}
                          >
                            {subItem.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  item.href.startsWith('#') ? (
                    <a
                      href={item.href}
                      className="text-gray-700 hover:text-amber-700 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {item.name}
                    </a>
                  ) : (
                    <Link
                      to={item.href}
                      className="text-gray-700 hover:text-amber-700 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {item.name}
                    </Link>
                  )
                )}
              </div>
            ))}
            <a
              href="https://wa.me/905303030218"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-600 text-white px-6 py-2.5 rounded-lg hover:bg-green-700 transition-colors duration-200 flex items-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              WhatsApp
            </a>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-gray-700 hover:text-amber-700 cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            {menuItems.map((item) => (
              <div key={item.name}>
                {item.hasDropdown ? (
                  <div>
                    <button
                      onClick={() => setIsProductsOpen(!isProductsOpen)}
                      className="w-full text-left py-3 text-gray-700 hover:text-amber-700 font-medium transition-colors duration-200 cursor-pointer flex items-center justify-between"
                    >
                      {item.name}
                      <i className={`ri-arrow-${isProductsOpen ? 'up' : 'down'}-s-line text-lg`}></i>
                    </button>
                    {isProductsOpen && (
                      <div className="pl-4 pb-2">
                        {item.submenu?.map((subItem) => (
                          <Link
                            key={subItem.name}
                            to={subItem.href}
                            className="block py-2 text-gray-600 hover:text-amber-700 transition-colors duration-200 cursor-pointer"
                            onClick={() => setIsMenuOpen(false)}
                          >
                            {subItem.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ) : (
                  item.href.startsWith('#') ? (
                    <a
                      href={item.href}
                      className="block py-3 text-gray-700 hover:text-amber-700 font-medium transition-colors duration-200 cursor-pointer"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {item.name}
                    </a>
                  ) : (
                    <Link
                      to={item.href}
                      className="block py-3 text-gray-700 hover:text-amber-700 font-medium transition-colors duration-200 cursor-pointer"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {item.name}
                    </Link>
                  )
                )}
              </div>
            ))}
            <a
              href="https://wa.me/905303030218"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-3 bg-green-600 text-white px-6 py-2.5 rounded-lg hover:bg-green-700 transition-colors duration-200 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              WhatsApp
            </a>
          </div>
        )}
      </nav>
    </header>
  );
}
